// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

/**
 * InternalReportingApi - axios parameter creator
 * @export
 */
export const InternalReportingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get completed Reposits report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompletedReposits(options: any = {}): RequestArgs {
            const localVarPath = `/v2/internal-reports/completed-reposits`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get created Reposits report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCreatedReposits(options: any = {}): RequestArgs {
            const localVarPath = `/v2/internal-reports/created-reposits`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InternalReportingApi - functional programming interface
 * @export
 */
export const InternalReportingApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Get completed Reposits report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompletedReposits(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = InternalReportingApiAxiosParamCreator(configuration).getCompletedReposits(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get created Reposits report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCreatedReposits(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = InternalReportingApiAxiosParamCreator(configuration).getCreatedReposits(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * InternalReportingApi - factory interface
 * @export
 */
export const InternalReportingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Get completed Reposits report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompletedReposits(options?: any) {
            return InternalReportingApiFp(configuration).getCompletedReposits(options)(axios, basePath);
        },
        /**
         * Get created Reposits report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCreatedReposits(options?: any) {
            return InternalReportingApiFp(configuration).getCreatedReposits(options)(axios, basePath);
        },
    };
};

/**
 * InternalReportingApi - interface
 * @export
 * @interface InternalReportingApi
 */
export interface InternalReportingApiInterface {
    /**
     * Get completed Reposits report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalReportingApiInterface
     */
    getCompletedReposits(options?: any): AxiosPromise<string>;

    /**
     * Get created Reposits report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalReportingApiInterface
     */
    getCreatedReposits(options?: any): AxiosPromise<string>;

}

/**
 * InternalReportingApi - object-oriented interface
 * @export
 * @class InternalReportingApi
 * @extends {BaseAPI}
 */
export class InternalReportingApi extends BaseAPI implements InternalReportingApiInterface {
    /**
     * Get completed Reposits report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalReportingApi
     */
    public getCompletedReposits(options?: any) {
        return InternalReportingApiFp(this.configuration).getCompletedReposits(options)(this.axios, this.basePath);
    }

    /**
     * Get created Reposits report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalReportingApi
     */
    public getCreatedReposits(options?: any) {
        return InternalReportingApiFp(this.configuration).getCreatedReposits(options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for InternalReportingApi
 * Import individual functions for optimal bundle size
 */
/**
 * Get completed Reposits report
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function getCompletedReposits(
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<string> {
    const localVarAxiosArgs = InternalReportingApiAxiosParamCreator(configuration).getCompletedReposits(options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get created Reposits report
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function getCreatedReposits(
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<string> {
    const localVarAxiosArgs = InternalReportingApiAxiosParamCreator(configuration).getCreatedReposits(options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

